<script setup lang="ts">

useSeoMeta({
  title: "Impressum",
  ogTitle: "Impressum"
})
</script>
<template>
  <PublicPageIntro eyebrow="Rechtliches" title="Impressum" compact />
  <PublicLegalContent>
    <h3>Adresse</h3>
    <p>
      Stefan Schäfer<br>
      Ennspark 193<br>
      5542 Flachau<br>
      ATU75521945<br>
      <br>
    </p>
    <h3>Kontaktaufnahme</h3>
    <p>
      <a href="mailto:info@mody.at">info@mody.at</a><br>
    </p>
  </PublicLegalContent>
</template>
